import Message from "@skrice.studio/mavia-common/build/models/messages/Message";
import { Alert, Box, Button, Chip, Grid } from "@mui/material";
import axios from "axios";
import * as React from "react";
import CustomScroll from "react-customscroll";
import { Avatar } from "../../../components/Avatar";
import { InventoryIcon } from "../../../components/InventoryIcon";
import { Config } from "../../../config/config";
import { getGlobalVar, Helpers } from "../../../utils/helpers";
import { PopupMessage } from "../../../utils/message";
import { DefaultProps } from "../../LayoutWrapper";

const CustomScrollWrapped: any = CustomScroll;

interface State {
    loaded: boolean;
    messages: any[];
    latestMessage: null | string;
    allLoaded: boolean;
    activeMessage: string | null;
}

interface Props extends DefaultProps {
    playerId: string;
    type: "received" | "sent";
}

export class MessagesList extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            messages: [],
            loaded: false,
            latestMessage: null,
            allLoaded: false,
            activeMessage: null,
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        try {
            const response = await axios.get(
                `${Config.getInstance.apiUrl}/api/user/${this.props.playerId}/messages/${this.props.type}/${this.state.latestMessage}`,
                {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                },
            );

            const allLoaded = response.data.length === 0;

            this.setState({
                ...(!allLoaded && {
                    messages: [...this.state.messages, ...response.data],
                    latestMessage: response.data[response.data.length - 1].created_at,
                    ...(this.state.messages.length === 0 && {
                        activeMessage: response.data[0].id,
                    })
                }),
                allLoaded,
                loaded: true,
            });
        } catch (e) {
            PopupMessage.error("Failed to load messages: " + e.message);
        }
    }

    translate(item: Message, type: "title" | "message") {
        if (item.translatable) {
            return Helpers.getLocalizationName(item[type], item.metadata);
        }

        return item.message;
    }

    getAvatar(item: Message) {
        if (item.sender_id === "00000000-0000-0000-0000-000000000000") {
            const image = require(`../../../../assets/images/misc/not_found.png`).default;

            return <img src={image}/>
        }

        return <div className="real-user">
            <div className="avatar">{Avatar(item.sender_meta, "small")}</div>
            <span className="username">{item.sender_meta.name}</span>
        </div>
    }

    getItemName(itemId: string) {
        const item = getGlobalVar("ITEMS").find(itemObject => itemObject.id === itemId);
        return item ? Helpers.getLocalizationName(item.name) : itemId;
    }

    setActiveMessage(messageId: string) {
        this.setState({
            activeMessage: messageId,
        })
    }

    renderActiveMessage() {
        if (!this.state.activeMessage) {
            return null;
        }

        const message = this.state.messages.find(messageItem => messageItem.id === this.state.activeMessage);

        return <React.Fragment>
            <div className="message-header">
                <div className="header-wrapper">
                    <h3>{this.translate(message, "title")}</h3>
                    <span className="date">{Helpers.formatTimeAgo(message.created_at)}</span>
                </div>
                <div className="tags">
                    {message.read_at && <Chip label="Read" size="small"/>}
                    {message.claimed_at && <Chip label="Claimed" size="small" style={{ marginLeft: 5 }}/>}
                </div>
            </div>
            <div className="content">
                {this.translate(message, "message")}

                {message.type === "PRIZE_MESSAGE" && <div className="rewards">
                    <Grid container spacing={2} style={{ marginTop: 15 }}>
                        {message.rewards.map((reward, index) => (
                            <Grid item sm={1} key={reward.item + index}>
                                <Box style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                    <div>
                                        {InventoryIcon({
                                            itemId: reward.item,
                                            style: { maxWidth: 70 },
                                            amountStyle: { fontSize: 16 },
                                            amount: reward.amount,
                                        })}
                                    </div>
                                    <div style={{ marginTop: 5, textAlign: "center", fontSize: 12 }}>
                                        {this.getItemName(reward.item)}
                                    </div>
                                </Box>

                            </Grid>
                        ))}
                    </Grid>
                </div>}
            </div>
        </React.Fragment>
    }

    render() {
        const messagesCount = (this.state.messages || []).length;

        if (messagesCount === 0) {
            return <Alert severity="info">No messages found</Alert>;
        }

        return <div className="user-messages">
            <div className="leftColumn">
                <div className="messagesList">
                    <CustomScrollWrapped>
                        {(this.state.messages || []).map(item => (
                            <div
                                className={`message ${this.state.activeMessage === item.id ? "active" : ""}`}
                                onClick={e => this.setActiveMessage(item.id)}
                            >
                                <div className="avatar">
                                    <div className="avatar-wrapper">
                                        {this.getAvatar(item)}
                                    </div>
                                </div>
                                <div className="message-inner">
                                    <h3>{this.translate(item, "title")}</h3>
                                    <span className="date">{Helpers.formatTimeAgo(item.created_at)}</span>
                                </div>
                            </div>
                        ))}
                    </CustomScrollWrapped>
                </div>
                {!this.state.allLoaded && <Button
                    disableElevation
                    size="small"
                    color="primary"
                    variant="contained"
                    style={{ marginTop: 25, width: "100%" }}
                    onClick={() => this.fetchData()}
                >
                    Load more
                </Button>}
            </div>

            <div className="activeMessage-wrapper">
                <div className="activeMessage">
                    {this.renderActiveMessage()}
                </div>
            </div>
        </div>;
    }
}
